var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_430)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 101,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9983 0H-0.00170898V100H99.9983V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9983 100C77.6125 100 99.9983 77.6142 99.9983 50C99.9983 22.3858 77.6125 0 49.9983 0C22.3841 0 -0.00170898 22.3858 -0.00170898 50C-0.00170898 77.6142 22.3841 100 49.9983 100Z",
    fill: "url(#paint0_radial_18_430)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.00170898,
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1497 47.975L54.1825 41.511",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9067 38.5109L65.6442 32.2812",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2395 39.0297L42.402 47.6906",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4795 47.0593C36.4795 45.9546 35.5842 45.0593 34.4795 45.0593H30.4795C29.3764 45.0593 28.4795 45.9546 28.4795 47.0593V69.5078C28.4795 70.6109 29.3764 71.5078 30.4795 71.5078H34.4795C35.5842 71.5078 36.4795 70.6109 36.4795 69.5078V47.0593Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2854 57.5375C48.2854 56.4344 47.3901 55.5375 46.2854 55.5375H42.2854C41.1807 55.5375 40.2854 56.4344 40.2854 57.5375V69.5078C40.2854 70.6109 41.1807 71.5078 42.2854 71.5078H46.2854C47.3901 71.5078 48.2854 70.6109 48.2854 69.5078V57.5375Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8514 49.6797C59.8514 48.5766 58.9545 47.6797 57.8514 47.6797H53.8499C52.7467 47.6797 51.8499 48.5766 51.8499 49.6797V69.5078C51.8499 70.6109 52.7467 71.5078 53.8499 71.5078H57.8514C58.9545 71.5078 59.8514 70.6109 59.8514 69.5078V49.6797Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5168 41.5671C71.5168 40.464 70.62 39.5671 69.5168 39.5671H65.5168C64.4122 39.5671 63.5168 40.464 63.5168 41.5671V69.5078C63.5168 70.6109 64.4122 71.5078 65.5168 71.5078H69.5168C70.62 71.5078 71.5168 70.6109 71.5168 69.5078V41.5671Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6848 39.6344C33.9577 39.6344 34.9895 38.6026 34.9895 37.3297C34.9895 36.0569 33.9577 35.025 32.6848 35.025C31.412 35.025 30.3801 36.0569 30.3801 37.3297C30.3801 38.6026 31.412 39.6344 32.6848 39.6344Z",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2063 51.5188C45.4791 51.5188 46.511 50.487 46.511 49.2141C46.511 47.9413 45.4791 46.9094 44.2063 46.9094C42.9335 46.9094 41.9016 47.9413 41.9016 49.2141C41.9016 50.487 42.9335 51.5188 44.2063 51.5188Z",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9846 42.3344C57.2575 42.3344 58.2893 41.3025 58.2893 40.0297C58.2893 38.7568 57.2575 37.725 55.9846 37.725C54.7118 37.725 53.6799 38.7568 53.6799 40.0297C53.6799 41.3025 54.7118 42.3344 55.9846 42.3344Z",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4053 33.1016C68.6781 33.1016 69.71 32.0697 69.71 30.7969C69.71 29.524 68.6781 28.4922 67.4053 28.4922C66.1324 28.4922 65.1006 29.524 65.1006 30.7969C65.1006 32.0697 66.1324 33.1016 67.4053 33.1016Z",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18_430",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18_430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2574 49.7409) rotate(-64.006) scale(69.7502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862101,
    stopColor: "#EFFBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_18_430",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.ea5fb695c9f5528892aa2b979dd93928.svg";
export { ForwardRef as ReactComponent };